<style>
#areas {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: top;
    display: flex;
}

.area {
    width: 110px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
}

.area:hover {
    opacity: 0.5;
    cursor: pointer;
}

.area-image-holder {
    display: inline-block;
    width: 100%;
    height: 80px;
    background-size: cover;
    border-radius: 10px;
    overflow: hidden;
}

.official-label {
    width: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
}

span {
	color: rgb(0,100,200);
}

@media (max-width:972px) {
    .area {
        margin-right: 7px;
        width: 80px;
    }
    .area:hover {
        opacity: 1.0;
    }
}
</style>

<script>
import {push} from './pt-router/Router.svelte'
import Spinner from './Spinner.svelte'

export let areas = []

function makeGoToArea(area_id) {
    return function() {
        push('/area/' + area_id)
    }
}
</script>

<div id="areas">
    {#if areas.length == 0}
        <Spinner></Spinner>
    {:else}
        {#each areas as area}
            <div on:click={makeGoToArea(area.id)} class="area">
                <div class="area-image-holder" style={"background-image:" + "url('/areas/" + area.id + ".jpg')"}>
                    {#if area.verified}<div class="official-label">Official Area</div>{/if}
                </div>
                <br>
                <span>{area.name}</span>
            </div>
        {/each}
    {/if}
</div>